import { z } from "zod"
import { emailSchema } from "../common/email-validator"
import { TranslationKey } from "../i18n/translation-key"

export const storeSlugSchema = () =>
  z
    .string()
    .min(3, "common.validation.slugMinLength" satisfies TranslationKey)
    .max(255, "common.validation.slugMaxLength" satisfies TranslationKey)
    .regex(
      /^[a-z0-9]+(-[a-z0-9]+)*$/,
      "common.validation.slugCharacters" satisfies TranslationKey,
    )

export const UpdateStoreAdminSchema = z.object({
  email: emailSchema().optional(),
  slug: storeSlugSchema().optional(),
  hiddenOnJulo: z.boolean().optional(),
  stripePayoutsEnabled: z.boolean().optional(),
  whiteLabelBookingEnabled: z.boolean().optional(),
  companiesEnabled: z.boolean().optional(),
  customerClubEnabled: z.boolean().optional(),
  testMode: z.boolean().optional(),
})

export type UpdateStoreAdmin = z.infer<typeof UpdateStoreAdminSchema>
